import isNumber from './is-number';
/**
 * 判断值是否为整数
 * @return 是否为整数
 */
export default function isInteger(value) {
    return isNumber(value) && value % 1 === 0;
}
//# sourceMappingURL=is-integer.js.map